import axios from 'axios'

const state = {
    individual_entity: {},
    individual_entities: {},
    individual_entity_errors: {},
    individual_entity_loading: false,
    payments: {},
}

const getters = {
    individual_entity: state => state.individual_entity,
    individual_entities: state => state.individual_entities,
    individual_entity_errors: state => state.individual_entity_errors,
    individual_entity_loading: state => state.individual_entity_loading,
    payments: state => state.payments,
}

const mutations = {
    setIndividualEntity(state, individual_entity) {
        state.individual_entity = individual_entity
    },
    setIndividualEntities(state, individual_entities) {
        state.individual_entities = individual_entities
    },
    setIndividualEntityErrors(state, individual_entity_errors) {
        state.individual_entity_errors = individual_entity_errors
    },
    setIndividualEntityLoading(state, individual_entity_loading) {
        state.individual_entity_loading = individual_entity_loading
    },
    setPayments(state, payments){
        state.payments = payments
    }
}

const actions = {
    async IndividualEntityStore({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.post(`/api/entities/individual/store`,data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },
    async IndividualEntitySendVerificationCode({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.post(`/api/entities/individual/verification-code`,data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },

    async updateIndividualEntity({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.put(`/api/admin/entities/individual/${data.id}/update`,data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return {ok: false, message: error.response.data?.message}
        }
    },
    async verifyIndividual({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.post(`/api/entities/individual/verify`,data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getIndividualEntity({commit}, id) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/individual/${id}/show`)
            commit('setIndividualEntity', response.data.data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response?.data?.errors ?? {})
            // the page redirects away on 404
            return {ok: false, status: error.response?.status}
        }
    },
    async getPayments({commit}, {params}) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/payments`, {params})
            commit('setPayments', response.data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getIndividualEntities({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/individual`,data)
            commit('setIndividualEntities', response.data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getRealIndividualEntities({commit}, data) {
        commit('setIndividualEntityLoading', true)
        commit('setIndividualEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/individual/resources`,data)
            commit('setIndividualEntities', response.data)
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setIndividualEntityLoading', false)
            commit('setIndividualEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getRealLegalEntities({commit}, data) {
        commit('setLegalEntityLoading', true)
        commit('setLegalEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/legal/resources`,data)
            commit('setLegalEntities', response.data)
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', error.response.data.errors)
            return false
        }
    },


}

export default {
    state,
    getters,
    mutations,
    actions
}